// Outgoing-shipments API — endpoints injected into the single baseApi (ARCHITECTURE §7).
import { baseApi } from '@/lib/api/baseApi';
import { outgoingShipmentsEndpoints } from './outgoingShipments.queries';

export const outgoingShipmentsApi = baseApi.injectEndpoints({
  endpoints: outgoingShipmentsEndpoints,
});

export const {
  useGetOutgoingShipmentsQuery,
  useGetOutgoingShipmentFilterOptionsQuery,
  useGetOutgoingShipmentDetailQuery,
  useGetShipmentLinkedOrdersQuery,
  useGetShipmentAllocationsQuery,
  useCreateShipmentForOrderMutation,
  useCreateOutgoingShipmentMutation,
  useGetOutgoingShipmentFormQuery,
  useUpdateOutgoingShipmentMutation,
  useDeleteOutgoingShipmentMutation,
  useGetShipmentForFulfillQuery,
  useFulfillOutgoingShipmentMutation,
} = outgoingShipmentsApi;
